import React, { useEffect, useRef, useState } from 'react'
// import { Configuration, OpenAIApi } from 'openai';
import axios from 'axios';
import "./chatGPT.scss"
import { CopyOutlined, SendOutlined, DownloadOutlined } from '@ant-design/icons';

import { Button, message, Image, Input, Avatar, Tooltip, Row, Col, Form, InputNumber, Select, Segmented, List } from 'antd';
// import { setMinutes } from 'date-fns';
import SimpleBarReact from "simplebar-react";
import Iframe from 'react-iframe';
import ReactTextFormat from 'react-text-format';
import html2pdf from 'html2pdf.js';
import { t } from '@wangeditor/editor';
import { normalizeChatResponse } from './chatResponseUtils';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';

export function ChatGPT2(props) {
   const [form] = Form.useForm();
   const userRole = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   const { TextArea } = Input;
   const { Option } = Select;

   const [storedValues, setStoredValues] = useState([]);
   const [newQuestion, setNewQuestion] = useState('');
   const [botSearching, setBotSearching] = useState(false);
   const [chatMessages, setMessages] = useState([{ "role": "system", "content": "You are a helpful assistant." },]);
   const [isTyping, setIsTyping] = useState(false);

   // const configuration = new Configuration({
   //    apiKey: OpenAIApiKey,
   // });

   // const openai = new OpenAIApi(configuration);

   const messagesEndRef = useRef(null);

   const [systemPrompt, setSystemPrompt] = React.useState('You are a helpful assistant.');
   const [userPrompt, setUserPrompt] = React.useState('');
   const [completion, setCompletion] = React.useState('');
   const [xhr, setXhr] = React.useState(null);

   const [shouldRun, setShouldRun] = React.useState(false);
   const [running, setRunning] = React.useState(false);

   const [subject, setSubject] = useState('araling panlipunan');
   const [topic, setTopic] = useState(null);
   const [noi, setNOI] = useState(1);
   const [toq, setTOQ] = useState(['short answer']);
   const [lod, setLOD] = useState('easy');
   const [language, setLanguage] = useState('english');

   const [gradeLevel, setGradeLevel] = useState('kinder');
   // const [depEdCode, setDepEdCode] = useState(null);
   const [lessonTitle, setLessonTitle] = useState(null);
   const [lessonDescription, setLessonDescription] = useState(null);

   const [aiType, setAiType] = useState('lesson');
   const [otherResouce, setOtherResouce] = useState(null);
   const [selectedDocumentIdx, setSelectedDocumentIdx] = useState(-1);

   const otherResourceList = [
      {
         title: 'YOU.com',
         link: 'https://you.com',
         container: 'new window'
      },
      {
         title: 'to teach_',
         link: 'https://www.to-teach.ai/',
         container: 'iframe'
      },
      {
         title: 'Talk to Books',
         link: 'https://books.google.com/talktobooks/',
         container: 'new window'
      },
      {
         title: 'TinyWow',
         link: 'https://tinywow.com/',
         container: 'new window'
      },
   ]

   // function linkify(text) {
   //    var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
   //    return text.replace(urlRegex, function (url) {
   //       return '<a href="' + url + '" target="_blank">' + url + '</a>';
   //    });
   // }

   const copyText = (text) => {
      navigator.clipboard.writeText(text);
      const key = 'updatable';
      message.info({ content: 'Copied to clipboard!', key });
   };

   const handleDownloadResult = () => {
      var element = document.getElementById('result-gpt');

      if (element !== null) {
         var reportFileName = 'BraineeAI-Result.pdf';

         var opt = {
            margin: 0.5,
            filename: reportFileName,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
         };

         // New Promise-based usage:
         html2pdf().from(element).set(opt).save();
      }
   }

   const generateBotResponse = async () => {
      const question = newQuestion.trim();

      if (question !== '') {
         setBotSearching(true);
         var tmpMessage = [...chatMessages];
         tmpMessage.push({ "role": "user", "content": question });
         setMessages(tmpMessage);

         try {
            var tmpStoreMessage = [...storedValues];
            tmpStoreMessage.push({
               type: "question",
               message: question
            })
            setStoredValues(tmpStoreMessage);
            setNewQuestion('');
            // Scroll down to the bottom
            setIsTyping(true);
            messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });

            var url = `${process.env.REACT_APP_API_CPH}/openai/brainee-chat`;
            const response = await axios.post(url, {
               userRole,
               messages: tmpMessage
            });

            setIsTyping(false);

            if (response.data.choices) {
               const rawBotResponse = response.data.choices[0].message?.content || '';
               const botResponse = normalizeChatResponse(rawBotResponse);
               tmpStoreMessage.push({
                  type: "answer",
                  message: botResponse
               })
               setStoredValues(tmpStoreMessage);
               tmpMessage.push({ "role": "assistant", "content": rawBotResponse });
               setMessages(tmpMessage);
               // Scroll down to the bottom
               messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
            }
         }
         catch (ex) {
            setIsTyping(false);
            message.warning("Error connecting to the server. Please try again.");
            //console.log(ex);
         }

         setBotSearching(false)
      } else
         setNewQuestion('');
   };

   const AI_Greeting = () => {
      var greeting_msg =
         'Greetings! I am brAInee Bot, your Brainee LMS assistant. Ask me about lessons, assessments, assignments, classes, learners, grading, reports, or how to use Brainee LMS.';

      var tmpStoreMessage = [...storedValues];
      tmpStoreMessage.push({
         type: "answer",
         message: greeting_msg,
      });
      setStoredValues(tmpStoreMessage);
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
   }

   useEffect(() => {
      AI_Greeting();
   }, []);

   useEffect(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
   }, [isTyping]);

   useEffect(() => {
      // AI_Greeting();

      function BuildUserPrompt(type) {
         let retVal = '';
         if (aiType === 'assessment') {
            let type_of_questions = toq.join();

            retVal = `Generate an assessment based on the following parameters:
                     - Subject: ${subject}
                     - Grade Level: ${gradeLevel}
                     - Topic: ${topic}
                     - Number of Questions: ${noi}
                     - Question Type: ${type_of_questions}
                     - Difficulty Level: ${lod}
                     - Language: ${language}

                     Instructions:
                     - Ensure the assessment is appropriate for the specified grade level.
                     - Use clear and age-appropriate language throughout.
                     - Display the Subject and Topic at the beginning.
                     - Include a relevant icon that represents the topic.
                     - Provide the following for each question in order:
                     1. Question
                     2. Correct Answer
                     3. Explanation (simple and easy to understand)

                     Formatting:
                     - Keep the layout clean and consistent.
                     - Separate each question clearly.

                     Additional Requirement:
                     - End the assessment with a short greeting message for the teacher, including a heart and smiley emoji.`;
         } else if (aiType === 'lesson') {
            let otherParams = lessonDescription;

            retVal = `Generate a complete lesson package aligned with the Philippine DepEd Matatag curriculum using the parameters below:

                     Subject: ${subject}
                     Lesson Title: ${lessonTitle}
                     Grade Level: ${gradeLevel}
                     Language: ${language}

                     General Instructions:
                     - The lesson must be appropriate for ${gradeLevel} students.
                     - Use clear, age-appropriate language.
                     - The lesson will be delivered using the Brainee LMS E-Learning platform.
                     - Translate the entire lesson package into ${language}.
                     - Ensure all outputs are well-structured and formatted consistently.
                     - Make sure there are not unterminated strings or invalid characters (important for JSON compatibility).

                     Lesson Plan Template (follow EXACT structure):

                     1. Lesson Title: ${lessonTitle}
                     2. Topic
                     3. Subject: ${subject}
                     4. Grade Level: ${gradeLevel}
                     5. Objectives:
                        - Content Standard
                        - Performance Standard
                        - Learning Competencies
                     6. Teaching Materials (include descriptions of illustrations if applicable)
                     7. References:
                        - Provide at least 3 credible sources
                        - Use APA format
                        - Include page numbers and copyright year for books
                        - Include valid website links if applicable (make sure the link is accessible)
                     8. Specific Strategy (step-by-step instructions for teaching)
                     9. Lesson Procedure:
                        - Introduction
                        - Development
                        - Guided Practice
                        - Independent Practice
                        - Closure
                     10. Critical Thinking / Reflective Questions
                     11. 3-2-1 Strategy:
                        - 3: Takeaways (things learned)
                        - 2: Interesting points
                        - 1: Questions remaining

                     Additional Requirements:
                     ${otherParams}

                     Worksheet Requirement:
                     - Create at least 15 worksheet items based on the lesson.
                     - Include a mix of question types if appropriate.
                     - For each item, provide:
                     1. Question
                     2. Correct Answer
                     3. Explanation (clear and simple)

                     Output Rules:
                     - Keep formatting clean and consistent.
                     - Make sure the lesson plan is more presentable and do not show the JSON string version.
                     - Remove those # signs and * if not neccessary.`;
         }

         return retVal;
      }

      const handleStream = async (prompt) => {
         setCompletion("");
         setRunning(true);
         try {
            const jwt = localStorage.getItem("lms-jwt");
            const res = await fetch(`${process.env.REACT_APP_API_CPH}/openai/stream`, {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
                  ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
               },
               body: JSON.stringify({
                  prompt,
               }),
            });

            if (!res.ok) {
               setCompletion("Error: Failed to connect to the AI service.");
               return;
            }

            const reader = res.body.getReader();
            const decoder = new TextDecoder("utf-8");

            let partialText = "";
            let sseBuffer = "";

            while (true) {
               const { done, value } = await reader.read();
               if (done) break;

               sseBuffer += decoder.decode(value, { stream: true });

               let eventBoundaryIndex = sseBuffer.indexOf("\n\n");
               while (eventBoundaryIndex !== -1) {
                  const rawEvent = sseBuffer.slice(0, eventBoundaryIndex);
                  sseBuffer = sseBuffer.slice(eventBoundaryIndex + 2);

                  const data = rawEvent
                     .split(/\r?\n/)
                     .filter((line) => line.startsWith("data:"))
                     .map((line) => line.replace(/^data:\s?/, ""))
                     .join("\n")
                     .trim();

                  if (!data) {
                     eventBoundaryIndex = sseBuffer.indexOf("\n\n");
                     continue;
                  }

                  if (data === "[DONE]") {
                     return;
                  }

                  try {
                     const json = JSON.parse(data);
                     const content = json.choices?.[0]?.delta?.content;
                     if (content) {
                        partialText += content;
                        setCompletion(partialText);
                        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
                     }
                  } catch (parseError) {
                     // Ignore malformed SSE fragments instead of breaking the full stream.
                     console.warn("Skipping unparsable SSE event chunk", parseError);
                  }

                  eventBoundaryIndex = sseBuffer.indexOf("\n\n");
               }
            }
         } catch (error) {
            setCompletion("Error: Failed to stream response. Please try again.");
         } finally {
            setRunning(false);
         }
      }

      if (shouldRun && !running) {
         setShouldRun(false);
         setRunning(true);
         setCompletion('');

         let prompt = BuildUserPrompt(aiType);

         handleStream(prompt);

         // var url = `${process.env.REACT_APP_API_CPH}/openai`;
         // axios.post(url, {
         //    model: "gpt-4o-2024-11-20",
         //    max_tokens: 5000,
         //    temperature: 0.5,
         //    messages: [
         //       { role: 'system', content: systemPrompt },
         //       { role: 'user', content: prompt },
         //    ],
         //    stream: false
         // }).then(response => {
         //    console.log(response);
         //    if (response.data) {
         //       setRunning(false);

         //       if (response.data.choices) {
         //          let result = response.data.choices[0].message?.content.trim();
         //          setCompletion(result);
         //          setXhr(null);
         //          messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
         //       }
         //    }
         // }, (error) => {
         //    console.log(error.message);
         //    setRunning(false);
         // });

         // const xhr = OpenAIExt.streamClientChatCompletion(
         //    {
         //       // model: 'gpt-3.5-turbo-0125',
         //       // model: "gpt-4o-2024-08-06",
         //       model: "gpt-4o-2024-11-20",
         //       max_tokens: 10000,
         //       temperature: 0.5,
         //       n: 1,
         //       messages: [
         //          { role: 'system', content: systemPrompt },
         //          { role: 'user', content: prompt },
         //       ],
         //    },
         //    {
         //       // apiKey: process.env.REACT_APP_OPENAI_API_KEY,
         //       apiKey: OpenAIApiKey,
         //       handler: {
         //          onContent(contentDraft, isFinal, xhr) {
         //             setCompletion(contentDraft);
         //             messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
         //          },
         //          onDone(xhr) {
         //             setRunning(false);
         //             setXhr(null);
         //          },
         //          onError(error, status, xhr) {
         //             console.error(error);
         //             setXhr(null);
         //             setRunning(false);
         //          },
         //       },
         //    },
         // );

         // setXhr(xhr);
      }
   }, [aiType, gradeLevel, language, lod, noi, lessonTitle, running, shouldRun, subject, systemPrompt, topic, toq, userPrompt]);


   const handleShowAIType = (val) => {
      setAiType(val);
   }

   const onFinish = (values) => {
      console.log('Success:', values);
      setShouldRun(true);
   };

   const onFinishFailed = (errorInfo) => {
      console.log('Failed:', errorInfo);
   };

   function showFunctionDescription(aiType) {
      if (aiType === 'lesson') {
         return (
            <div style={{ display: "block", textAlign: "center" }}>
               <h5 style={{ marginBottom: "-2px", marginTop: "3px" }}>Create a Learning Plan</h5>
               <span>Create a learning plan for the topic of your choice</span>
            </div>
         )
      } else if (aiType === 'assessment') {
         return (
            <div style={{ display: "block", textAlign: "center" }}>
               <h5 style={{ marginBottom: "-2px", marginTop: "3px" }}>Create Assessment/Quiz</h5>
               <span>Create an Assessment or Quiz to the topic of your choice</span>
            </div>
         )
      } else if (aiType === 'other resource') {
         return (
            <div style={{ display: "block", textAlign: "center" }}>
               <h5 style={{ marginBottom: "-2px", marginTop: "3px" }}>Get Resouces</h5>
               <span>Get resources from other AI tools</span>
            </div>
         )
      } else if (aiType === 'braineebot') {
         return (
            <div style={{ display: 'block', textAlign: 'center' }}>
               <h5 style={{ marginBottom: '-2px', marginTop: '3px' }}>
                  Ask Brainee Bot
               </h5>
               <span>Ask Brainee Bot to search for resources</span>
            </div>
         );
      }
   }

   function showFunctionInputs(aiType) {
      if (aiType === 'assessment') {
         return (
            <>
               <Form
                  form={form}
                  layout={"vertical"}
                  colon={false}
                  className='aiform'
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
               >
                  <SimpleBarReact key={'uid'} style={{ maxHeight: "calc(100vh - 317px)" }}>
                     <Form.Item name="subject" label="Subject"
                        rules={[{
                           required: true,
                           message: 'Subject should not be blank'
                        }]}
                        initialValue={subject}
                     >
                        <Select
                           key={'uid'}
                           showArrow
                           size='large'
                           style={{ width: '100%' }}
                           allowClear
                           placeholder="Select subject"
                           // defaultValue={'araling panlipunan'}
                           onChange={(val) => setSubject(val)}
                        >
                           <Option value={'arts'}>Arts</Option>
                           <Option value={'araling panlipunan'}>Araling Panlipunan</Option>
                           <Option value={'edukasyong pantahanan at pangkabuhayan'}>Edukasyong Pantahanan at Pangkabuhayan</Option>
                           <Option value={'edukasyong sa pagpapakatao'}>Edukasyon sa Pagpapakatao</Option>
                           <Option value={'english'}>English</Option>
                           <Option value={'filipino'}>Filipino</Option>
                           <Option value={'mathematics'}>Mathematics</Option>
                           <Option value={'music'}>Music</Option>
                           <Option value={'p.e. and health'}>P.E. and Health</Option>
                           <Option value={'science'}>Science</Option>
                           <Option value={'technology and livelihood education'}>Technology and Livelihood Education</Option>
                        </Select>
                     </Form.Item>
                     <Form.Item name="gradelevel" label="Grade Level"
                        rules={[{
                           required: true,
                           message: 'Grade level should not be blank'
                        }]}
                        initialValue={gradeLevel}
                     >
                        <Select
                           key={'uid'}
                           showArrow
                           size='large'
                           style={{ width: '100%' }}
                           allowClear
                           placeholder="Select grade level"
                           // defaultValue={'kinder'}
                           onChange={(val) => setGradeLevel(val)}
                        >
                           <Option value={'kinder'}>Kinder</Option>
                           <Option value={'grade 1'}>Grade 1</Option>
                           <Option value={'grade 2'}>Grade 2</Option>
                           <Option value={'grade 3'}>Grade 3</Option>
                           <Option value={'grade 4'}>Grade 4</Option>
                           <Option value={'grade 5'}>Grade 5</Option>
                           <Option value={'grade 6'}>Grade 6</Option>
                           <Option value={'grade 7'}>Grade 7</Option>
                           <Option value={'grade 8'}>Grade 8</Option>
                           <Option value={'grade 9'}>Grade 9</Option>
                           <Option value={'grade 10'}>Grade 10</Option>
                           <Option value={'grade 11'}>Grade 11</Option>
                           <Option value={'grade 12'}>Grade 12</Option>
                        </Select>
                     </Form.Item>
                     <Form.Item name="topic" label="Topic"
                        rules={[{
                           required: true,
                           message: 'Topic should not be blank'
                        }]}
                     >
                        <Input
                           key={'uid'}
                           allowClear
                           size='large'
                           style={{ borderRadius: 7 }}
                           placeholder="Enter Topic"
                           onBlur={(event) => setTopic(event.target.value)}
                        />
                     </Form.Item>
                     <Form.Item name="noi" label="Number of Items"
                        rules={[{
                           required: true,
                           message: 'Number of items should not be blank'
                        }]}
                        initialValue={noi}
                     >
                        <InputNumber
                           key={'uid'}
                           size='large'
                           style={{ borderRadius: 7, width: "100%" }}
                           // defaultValue={1}
                           min="1"
                           max='100'
                           onChange={(val) => setNOI(val)}
                        />
                     </Form.Item>
                     <Form.Item name="toq" label="Type of Question/s"
                        rules={[{
                           required: true,
                           message: 'Type of question should not be blank'
                        }]}
                        initialValue={toq}
                     >
                        <Select
                           key={'uid'}
                           showArrow
                           size='large'
                           style={{ width: '100%' }}
                           allowClear
                           placeholder="Select type of question"
                           // defaultValue={'short answer'}
                           onChange={(val) => setTOQ(val)}
                           mode="multiple"
                        >
                           <Option value={'short answer'}>Short Answer</Option>
                           <Option value={'multiple choice'}>Mutiple Choice</Option>
                           <Option value={'true or false'}>True or False</Option>
                           <Option value={'multiple choice with multiple correct answers'}>Multiple Answers</Option>
                           <Option value={'open-ended, essay'}>Open-ended/Essay</Option>
                           <Option value={'fill in the blank with choices'}>Fill in the Blank</Option>
                           <Option value={'matching type'}>Matching Type</Option>
                        </Select>
                     </Form.Item>
                     <Form.Item name="lod" label="Level of Difficulty"
                        rules={[{
                           required: true,
                           message: 'Level of difficulty should not be blank'
                        }]}
                        initialValue={lod}
                     >
                        <Select
                           key={'uid'}
                           showArrow
                           size='large'
                           style={{ width: '100%' }}
                           allowClear
                           placeholder="Select difficulty level"
                           // defaultValue={'easy'}
                           onChange={(val) => setLOD(val)}
                        >
                           <Option value={'easy'}>Easy</Option>
                           <Option value={'average'}>Average</Option>
                           <Option value={'difficult'}>Difficult</Option>
                        </Select>
                     </Form.Item>

                     <Form.Item name="translation" label="Translation"
                        rules={[{
                           required: true,
                           message: 'Translation should not be blank'
                        }]}
                        initialValue={language}
                     >
                        <Select
                           key={'uid'}
                           showArrow
                           size='large'
                           style={{ width: '100%' }}
                           allowClear
                           placeholder="Select translation"
                           // defaultValue={'english'}
                           onChange={(val) => setLanguage(val)}
                        >
                           <Option value={'english'}>English</Option>
                           <Option value={'tagalog'}>Filipino</Option>
                           {/* <Option value={'japanese'}>Japanese</Option>
                           <Option value={'arabic'}>Arabic</Option> */}
                        </Select>
                     </Form.Item>
                  </SimpleBarReact>

                  <Row gutter={[10, 10]} style={{ marginTop: "5px" }}>
                     <Col sm={24} md={12} lg={12}>
                        {
                           running
                              ?
                              <Button className='button-shadow' size='middle' type="primary" shape='round' block loading={running}
                                 htmlType='submit'
                              >
                                 Generating...
                              </Button>
                              :
                              <Button className='button-shadow' size='middle' type="primary" shape='round' block loading={running}
                                 htmlType='submit'
                              >
                                 <SendOutlined />Generate
                              </Button>
                        }

                     </Col>
                     <Col sm={24} md={12} lg={12}>
                        <Button className='button-shadow' size='middle' type="primary" shape='round' block disabled={!running} onClick={() => xhr?.abort()}>
                           Stop
                        </Button>
                     </Col>
                  </Row>
               </Form>

            </>
         )
      } else if (aiType === 'lesson') {
         return (
            <>
               <Form
                  form={form}
                  layout={"vertical"}
                  colon={false}
                  className='aiform'
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
               >
                  <SimpleBarReact key={'uid'} style={{ maxHeight: "calc(100vh - 317px)" }}>
                     <Form.Item name="subject" label="Subject"
                        rules={[{
                           required: true,
                           message: 'Subject should not be blank'
                        }]}
                        initialValue={subject}
                     >
                        <Select
                           key={'uid'}
                           showArrow
                           size='large'
                           style={{ width: '100%' }}
                           allowClear
                           placeholder="Select subject"
                           // defaultValue={'araling panlipunan'}
                           onChange={(val) => setSubject(val)}
                        >
                           <Option value={'arts'}>Arts</Option>
                           <Option value={'araling panlipunan'}>Araling Panlipunan</Option>
                           <Option value={'edukasyong pantahanan at pangkabuhayan'}>Edukasyong Pantahanan at Pangkabuhayan</Option>
                           <Option value={'edukasyong sa pagpapakatao'}>Edukasyon sa Pagpapakatao</Option>
                           <Option value={'english'}>English</Option>
                           <Option value={'filipino'}>Filipino</Option>
                           <Option value={'mathematics'}>Mathematics</Option>
                           <Option value={'music'}>Music</Option>
                           <Option value={'p.e. and health'}>P.E. and Health</Option>
                           <Option value={'science'}>Science</Option>
                           <Option value={'technology and livelihood education'}>Technology and Livelihood Education</Option>
                        </Select>
                     </Form.Item>
                     <Form.Item name="gradelevel" label="Grade Level"
                        rules={[{
                           required: true,
                           message: 'Grade level should not be blank'
                        }]}
                        initialValue={gradeLevel}
                     >
                        <Select
                           key={'uid'}
                           showArrow
                           size='large'
                           style={{ width: '100%' }}
                           allowClear
                           placeholder="Select grade level"
                           // defaultValue={'kinder'}
                           onChange={(val) => setGradeLevel(val)}
                        >
                           <Option value={'kinder'}>Kinder</Option>
                           <Option value={'grade 1'}>Grade 1</Option>
                           <Option value={'grade 2'}>Grade 2</Option>
                           <Option value={'grade 3'}>Grade 3</Option>
                           <Option value={'grade 4'}>Grade 4</Option>
                           <Option value={'grade 5'}>Grade 5</Option>
                           <Option value={'grade 6'}>Grade 6</Option>
                           <Option value={'grade 7'}>Grade 7</Option>
                           <Option value={'grade 8'}>Grade 8</Option>
                           <Option value={'grade 9'}>Grade 9</Option>
                           <Option value={'grade 10'}>Grade 10</Option>
                           <Option value={'grade 11'}>Grade 11</Option>
                           <Option value={'grade 12'}>Grade 12</Option>
                        </Select>
                     </Form.Item>
                     <Form.Item name="title" label="Lesson Title"
                        rules={[{
                           required: true,
                           message: 'Lesson Title should not be blank'
                        }]}
                     >
                        <Input
                           key={'uid'}
                           allowClear
                           size='large'
                           style={{ borderRadius: 7 }}
                           placeholder="Enter Lesson Plan on"
                           onBlur={(event) => setLessonTitle(event.target.value)}
                        />
                     </Form.Item>
                     <Form.Item name="description" label="Lesson Description"
                     // rules={[{
                     //    required: true,
                     //    message: 'Lesson Description should not be blank'
                     // }]}
                     >
                        <Input
                           key={'uid'}
                           allowClear
                           size='large'
                           style={{ borderRadius: 7 }}
                           placeholder="Enter Lesson Description"
                           onBlur={(event) => setLessonDescription(event.target.value)}
                        />
                     </Form.Item>

                     <Form.Item name="translation" label="Translation"
                        rules={[{
                           required: true,
                           message: 'Translation should not be blank'
                        }]}
                        initialValue={language}
                     >
                        <Select
                           key={'uid'}
                           showArrow
                           size='large'
                           style={{ width: '100%' }}
                           allowClear
                           placeholder="Select translation"
                           // defaultValue={'english'}
                           onChange={(val) => setLanguage(val)}
                        >
                           <Option value={'english'}>English</Option>
                           <Option value={'tagalog'}>Filipino</Option>
                           {/* <Option value={'japanese'}>Japanese</Option>
                           <Option value={'arabic'}>Arabic</Option> */}
                        </Select>
                     </Form.Item>
                  </SimpleBarReact>

                  <Row gutter={[10, 10]} style={{ marginTop: "5px" }}>
                     <Col sm={24} md={12} lg={12}>
                        {
                           running
                              ?
                              <Button className='button-shadow' size='middle' type="primary" shape='round' block loading={running}
                                 htmlType='submit'
                              >
                                 Generating...
                              </Button>
                              :
                              <Button className='button-shadow' size='middle' type="primary" shape='round' block loading={running}
                                 htmlType='submit'
                              >
                                 <SendOutlined />Generate
                              </Button>
                        }
                     </Col>
                     <Col sm={24} md={12} lg={12}>
                        <Button className='button-shadow' size='middle' type="primary" shape='round' block disabled={!running} onClick={() => xhr?.abort()}>
                           Stop
                        </Button>
                     </Col>
                  </Row>
               </Form>
            </>
         )
      } else if (aiType === "other resource") {
         return (
            <>
               <SimpleBarReact
                  style={{ height: "calc(100vh - 627px)", backgroundColor: "white", minHeight: "200px" }}
               // onClick={() => setSelectedDocumentIdx(-1)}
               >
                  <List
                     size="small"
                     dataSource={otherResourceList}
                     renderItem={(item, idx) =>
                        // <Tooltip placement="left" title={otherResourceList[idx].title}>
                        <List.Item
                           onClick={() => handleViewLink(otherResourceList[idx].link, otherResourceList[idx].container)}
                           className={idx === selectedDocumentIdx ? 'document-file-selected' : 'document-file'}
                           style={{ textAlign: "left", whiteSpace: "nowrap", textOverflow: "ellipsis", margin: "5px" }}
                        >
                           {otherResourceList[idx].title}
                        </List.Item>
                        // </Tooltip>
                     }
                  />
               </SimpleBarReact>
            </>
         )
      } else if (aiType === "braineebot") {
         // AI_Greeting();

         return (
            <>
               <TextArea
                  allowClear
                  showCount
                  value={newQuestion}
                  maxLength={500}
                  style={{ height: 220, resize: "none" }}
                  rows={8}
                  onChange={(e) => setNewQuestion(e.target.value)}
                  placeholder="Ask me anything..."
               // autoSize={{
               //    maxRows: 10,
               // }}
               />
               <Button className='button-shadow' size='middle' type="primary" shape='round' block loading={botSearching} onClick={() => generateBotResponse()}>
                  <SendOutlined /> Send Message
               </Button>
            </>
         )
      }
   }

   const handleViewLink = (link, container) => {
      if (container === 'iframe')
         setOtherResouce(link);
      else {
         setOtherResouce(null);
         window.open(link, '_blank').focus();
      }
   }

   return (
      <>
         <Row gutter={[0, 10]}>
            <Col xs={24} md={9} lg={9}>
               <div className='student_list_container' style={{ paddingRight: "10px", paddingBottom: "6px" }}>
                  <div style={{ paddingBottom: '10px' }}>
                     <Segmented
                        disabled={running ? true : false}
                        key={'uid'}
                        value={aiType}
                        block
                        options={[
                           {
                              label: 'Learning Plan',
                              value: 'lesson',
                              title: 'Learning Plan',
                           },
                           // {
                           //    label: 'Assessment/Quiz',
                           //    value: 'assessment',
                           //    title: 'Assessment/Quiz',
                           // },
                           {
                              label: 'Ask Brainee Bot',
                              value: 'braineebot',
                              title: 'Ask Brainee Bot',
                           },
                           // {
                           //    label: 'Other AI Resources',
                           //    value: 'other resource',
                           //    title: 'Other AI Resources',
                           // },
                        ]}
                        onChange={(val) => handleShowAIType(val)}
                     />
                     {
                        showFunctionDescription(aiType)
                     }
                  </div>

                  {
                     showFunctionInputs(aiType)
                  }

               </div>
            </Col>
            <Col xs={24} md={15} lg={15}>
               <div className="stream-answer-container">
                  {
                     aiType !== "other resource"
                        ?
                        <div style={{ position: "relative" }}>
                           <SimpleBarReact key={'uid'} style={{ maxHeight: "calc(100vh - 187px)" }}>
                              <div style={{ display: "flex", justifyContent: "center", paddingBottom: "20px", paddingTop: "10px" }}>
                                 {/* <Image src='../images/brainee_bot.png' preview={false} height="150px" /> */}
                              </div>
                              {
                                 aiType === 'braineebot'
                                    ?
                                    <>
                                       {storedValues.map((value, index) => {
                                          return (
                                             <div className="answer-section" key={index}>
                                                {value.type === "answer" &&
                                                   <>
                                                      <div style={{ display: "flex", justifyContent: "left", marginTop: '5px' }}>
                                                         <div style={{ paddingLeft: "5px", marginLeft: "10px", marginTop: "10px" }}>
                                                            {/* <Avatar src="../images/brainee_mascot.png" /> */}
                                                            {/* <Avatar src="../images/braineebot.png" /> */}
                                                            <Image src='../images/brainee_bot.png' preview={false} height="40px" />
                                                         </div>
                                                         <div style={{ maxWidth: "65%" }}>
                                                            <p className="answer">
                                                               <ReactTextFormat linkTarget="_blank">
                                                                  {value.message}
                                                               </ReactTextFormat>
                                                            </p>
                                                         </div>
                                                      </div>
                                                      <div className="copy-icon">
                                                         <Tooltip placement="top" title='Click to copy text'>
                                                            <CopyOutlined onClick={() => copyText(value.message)} />
                                                         </Tooltip>
                                                      </div>
                                                   </>
                                                }
                                                {value.type === "question" &&
                                                   <div style={{ display: "flex", justifyContent: "right" }}>
                                                      <div style={{ maxWidth: "65%" }}>
                                                         <p className="question">{value.message}</p>
                                                      </div>
                                                   </div>}
                                             </div>
                                          );
                                       })}
                                       {isTyping &&
                                          <div style={{ display: "flex" }}>
                                             <div style={{ paddingLeft: "5px", marginLeft: "10px", marginTop: "10px", marginBottom: '10px' }}>
                                                <Image src='../images/brainee_bot.png' preview={false} height="40px" />
                                             </div>
                                             <div className="typing">
                                                <div className="typing__dot" />
                                                <div className="typing__dot" />
                                                <div className="typing__dot" />
                                             </div>
                                          </div>}
                                       <div ref={messagesEndRef} />
                                    </>
                                    :
                                    <div className='wrapword' style={{ padding: "15px" }} id='result-gpt'>
                                       {normalizeChatResponse(completion)}
                                       {running && <>█</>}
                                    </div>
                              }


                              <div ref={messagesEndRef} />
                           </SimpleBarReact>
                           {
                              completion &&
                              <div style={{ display: "flex" }}>
                                 <div>
                                    <Tooltip placement="left" title='Click to copy results'>
                                       <div className="stream-copy-icon" style={{ right: 0 }}>
                                          <CopyOutlined onClick={() => copyText(normalizeChatResponse(completion))} />
                                       </div>
                                    </Tooltip>
                                 </div>
                                 <div>
                                    <Tooltip placement="left" title='Click to download results'>
                                       <div className="stream-copy-icon" style={{ right: 45 }}>
                                          <DownloadOutlined onClick={() => handleDownloadResult()} />
                                       </div>
                                    </Tooltip>
                                 </div>
                              </div>

                           }
                        </div>
                        :
                        <div style={{ display: "flex", height: "calc(100vh - 187px)" }}>
                           {
                              otherResouce !== null
                                 ?
                                 <Iframe
                                    id="otherresource"
                                    title="Other Resource"
                                    src={otherResouce}
                                    frameBorder="0"
                                    height='100%'
                                    width='100%'
                                 />
                                 :
                                 <div style={{ display: "flex", width: "100%", justifyContent: "center", paddingBottom: "20px", paddingTop: "10px" }}>
                                    <Image src='../images/brainee_bot.png' preview={false} height="150px" />
                                 </div>
                           }

                        </div>
                  }

               </div>
            </Col>
         </Row>
      </>
   )
}
